import { changeModuleStatus } from '../../../../services/popupApi';

export const api = {
  submit: async (values, context) => {
    await changeModuleStatus(context.moduleName, context.selectedIds, values.status);
  },
};
